import React, { Component } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'

class Form extends Component {
  state = { email: '', status: undefined }

  handleChange = e => this.setState({ email: e.target.value })

  handleSubmit = e => {
    e.preventDefault()
    const { email } = this.state

    addToMailchimp(email).then(data => {
      if (data.msg.includes('is already subscribed')) {
        this.setState({
          status: 'success'
        })
      } else {
        this.setState({
          status: data.result
        })
      }
      // No catch necesssary: Mailchimp always returns a 200 status code
    })
  }

  render() {
    const {
      handleSubmit,
      handleChange,
      state: { email, status }
    } = this

    if (status === undefined || status === 'error') {
      return (
        <form className="form" onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            placeholder="Your work email"
            onChange={handleChange}
            required
          />
          <input
            className="btn btn"
            type="submit"
            value={status === undefined ? 'Subscribe' : 'Try again'}
          />
        </form>
      )
    } else {
      return (
        <div className="btn form__btn-success">
          Thanks! Check your email to confirm
        </div>
      )
    }
  }
}

export default Form
